import React from 'react';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';

/**
 * Selection state
 *
 */
export default React.createClass({
  displayName: 'ItemNumberCell',

  propTypes: {
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { isSelected, rowIndex } = this.props;
    const iconName = isSelected ? 'check-circle' : 'circle-o';

    const { params } = this.context.router.state;

    return (
      <DisplayForAdmin {...params}>
        <div
          className={classNames('cs-row-selector', 'pointer', {
            'cs-row-selector-selected': isSelected === true,
          })}
          onClick={() => CuesheetRowActions.toggleRowSelection(rowIndex)}
        >
          <Icon name={iconName} size={2} />
        </div>
      </DisplayForAdmin>
    );
  },
});
